import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

import { IStyledVariantProps } from '../../../../model';
import { VariantCommon } from '../../variantsStyled';

type VariantProps = IStyledVariantProps & {
  newDesign: boolean;
  isDualPriceForCroatia: boolean;
};
export const Variant = styled(VariantCommon)<VariantProps>`
  ${({ newDesign, isSelected, isOnStock, isDualPriceForCroatia }) =>
    newDesign
      ? css`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: ${
            isOnStock && isDualPriceForCroatia ? 'center' : 'space-between'
          };
          margin: 0 0 0.25rem;
          border 2px solid ${
            isSelected
              ? theme.color.border.selected
              : isOnStock
              ? theme.color.border.divider
              : theme.color.common.gray90
          };
          background-color: ${theme.color.background.primary};
          height: 3.5rem;
          width: 6.5rem;
          padding: 0.625rem 0.5rem;
          @media (min-width: ${breakpoints.lg}) {
            width: auto;
            margin: 0;
          }
        `
      : css`
          min-height: 3.625rem;
          border 1px solid ${(props: IStyledVariantProps) =>
            props.isSelected
              ? props.theme.color.border.selected
              : props.theme.color.border.divider};
          background-color: ${(props) =>
            props.isSelected
              ? theme.color.background.primary
              : theme.color.background.disabled};

          &:hover {
            background-color: ${(props) =>
              !props.isSelected && theme.color.background.tertiary};
          }

          padding: 0.375rem 1.875rem 0.375rem 0.625rem;
          @media (min-width: ${breakpoints.sm}) {
            min-width: 6.8rem;
          }
        `}
`;

interface IPriceLabelWrapperProps {
  isOnStock: boolean;
  isSelected: boolean;
  newDesign: boolean;
}

export const PriceLabelWrapper = styled.div<IPriceLabelWrapperProps>`
  ${({ newDesign, isOnStock, isSelected }) =>
    newDesign
      ? css`
          ${theme.typography.labelSmall400}
          color:${theme.color.text.secondary}
        `
      : css`
          color: ${isOnStock
            ? theme.color.text.primary
            : theme.color.text.disabled};
          font-weight: ${isSelected ? 'bold' : 'normal'};
          font-size: 0.9rem;
        `}
`;

export const Unavailable = styled.p`
  ${theme.typography.labelSmall400}
  color:${theme.color.text.tertiary}
`;
